<template>
    	<v-select
            :items="languages"
            item-text="title"
            item-value="language"
            outlined
            v-model="language"
            dense
            width="11"
            class="shrink wdt"
            @change="reload"
        >
          <template v-slot:item="slotProps" >
              <i :class="['mr-2', 'em', `em-flag-${slotProps.item.flag.toLowerCase()}`]"></i>
              {{`${slotProps.item.title}` }}
          </template>
         <template slot="selection" slot-scope="data">
            <i :class="['mr-2', 'em', `em-flag-${data.item.flag.toLowerCase()}`]"></i>
            {{`${data.item.title }` }}
          </template>
        </v-select>
</template>
<script>
import i18n from '@/plugins/i18n';

export default {
    computed: {
      language: {
            get() {
                return this.$store.state.language;
            },
            set(val) {
                return this.$store.commit('SET_LANGUAGE', val);
            }
        },
    },
    data: () => ({
      languages: [
			  { flag: 'us', language: 'en', title: 'English' },
			  { flag: 'in', language: 'hi', title: 'हिन्दी' },
        { flag: 'in', language: 'mr', title: 'मराठी' },
        { flag: 'es', language: 'es', title: 'Spanish' },
        { flag: 'np', language: 'ne', title: 'Nepali' },
        { flag: 'id', language: 'id', title: 'Indonesia' },
        { flag: 'pt', language: 'pt', title: 'Portuguese' },
        { flag: 'gr', language: 'el', title: 'Greek' },
        { flag: 'tr', language: 'tr', title: 'Turkish' },
        { flag: 'ke', language: 'sw', title: 'kiswahili'},
        { flag: 'sa', language: 'ar', title: 'Arabic'},
        { flag: 'vi', language: 'vi', title: 'Vietnamese'},
        { flag: 'am', language: 'am', title: 'Amharic' },
        { flag: 'nl', language: 'nl', title: 'Dutch' },
      ]
    }),
    methods: {
      changeLocale(locale) {
        i18n.locale = locale;
      },
      reload(){
        if(this.pageReload == false) return
        this.$router.go()
      }
    },
    props: {
      pageReload: {
        type: Boolean,
        default: false,
        require: false
      }
    }
}
</script>
<style scoped lang="scss">
::v-deep .v-select__slot {
   font-size: 12px;
}
::v-deep .v-input__append-inner {
  display: none;
}

::v-deep.wdt {
    width: 100px !important;
}
</style>